import React, { memo } from 'react';
import { Advice } from '@Sage/hoi-poi-ui';

const CrudInfo = memo(({ text, showCollapse }) => {
    return (
        <Advice type="info" showCollapse={showCollapse}>
            {text}
        </Advice>
    );
});

export default CrudInfo;
